import Container from './FolderModal.container';
import FolderModal from './FolderModal';
export default Container(FolderModal);
